import Image from 'next/image';
import { Heading } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import logoDark from '~/public/as-appsumo-logo-dark.svg';

import { Link } from '~/components/global/Link';

export default function NavHeaderCheckout() {
  return (
    <div className="fixed top-0 left-0 z-10 h-[73px] w-full border-b border-navbar bg-navbar py-6 text-navbar">
      <div className="mx-auto max-w-screen-2xl px-4">
        <div className="flex items-center">
          <div className="grow">
            <Link href="/" className="block w-[100px] md:h-[23px] md:w-[150px]">
              <span className="sr-only">AppSumo</span>
              <Image
                alt="AppSumo"
                src={logoDark}
                width={150}
                height={23}
                priority
              />
            </Link>
          </div>
          <Link href="/cart/" className="flex items-center justify-center">
            <FontAwesomeIcon
              icon={faArrowLeft}
              height="16"
              className="mr-2 text-dorado"
            />
            <Heading.H5 className="text-midnight">Return to cart</Heading.H5>
          </Link>
        </div>
      </div>
    </div>
  );
}
